import { render } from "./klb.vue?vue&type=template&id=03f855c4&scoped=true"
import script from "./klb.vue?vue&type=script&lang=js"
export * from "./klb.vue?vue&type=script&lang=js"

import "./klb.vue?vue&type=style&index=0&id=03f855c4&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f855c4"]])

export default __exports__